export default __webpack_public_path__ + "static/media/drzewo_1.0e9ce4e6.svg";